/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authstartsignindifferent4Inputs */

const en_authstartsignindifferent4 = /** @type {(inputs: Authstartsignindifferent4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with a different one`)
};

const pt_authstartsignindifferent4 = /** @type {(inputs: Authstartsignindifferent4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar com outro email`)
};

/**
* | output |
* | --- |
* | "Sign in with a different one" |
*
* @param {Authstartsignindifferent4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsignindifferent4 = /** @type {((inputs?: Authstartsignindifferent4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsignindifferent4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsignindifferent4(inputs)
	return pt_authstartsignindifferent4(inputs)
});
export { authstartsignindifferent4 as "authStartSignInDifferent" }